function stickyNav(selector) {
	const nav = document.querySelector(selector);
	if (!nav) return;
	const scrollWatcher = document.createElement('div');
	scrollWatcher.setAttribute('data-scroll-watcher', '');
	nav.before(scrollWatcher);

	const navObserver = new IntersectionObserver(
		(entries) => {
			nav.classList.toggle('sticking', !entries[0].isIntersecting);
		}, { rootMargin: '50px 0px 0px 0px' }
	);

	navObserver.observe(scrollWatcher);
}

stickyNav('.page-template-page-pillar .site-header');
